import axios from "axios";

export default {
  async createCancelToken() {
    const source = axios.CancelToken.source();
    const { default: store } = await import("@/store/store");
    store.dispatch("requestQueue/add", source);
    return source;
  },
  defaultOptions(options = {}) {
    return {
      abortOnPageChange: true,
      ...options,
    };
  },
  async post(url, payload, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return axios.post(url, payload, {
      cancelToken: source.token,
      headers: options?.headers, // TKP-185 md.74: istek başına başlık (ör. hedef organizasyon) — istek başlığı genel başlığı ezer
    });
  },
  async put(url, payload, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return axios.put(url, payload, {
      cancelToken: source.token,
    });
  },
  async get(url, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return axios.get(url, {
      cancelToken: source.token,
      headers: options?.headers, // TKP-240 b.3: istek başına başlık (görevin organizasyonu) — post/delete gibi
    });
  },
  async delete(url, options) {
    const source = this.defaultOptions(options).abortOnPageChange ? await this.createCancelToken() : {};
    return axios.delete(url, {
      cancelToken: source.token,
      headers: options?.headers,
    });
  },
};
